{
  "it": {
    "levels": {
      "actions": {
        "add_customer": "Aggiungi cliente",
        "cancel": "Annulla",
        "changeLevel": "Cambia livello",
        "changeTargetGroup": "Cambia gruppo target",
        "delete": "Elimina",
        "removeCustomer": "Rimuovi cliente",
        "requestUnits": "Richiedi unità",
        "save": "Salva"
      },
      "building": "Edificio",
      "customers": "Clienti",
      "descriptions": {
        "mupCantDelete": "Sembra che ci siano ancora unità all'interno di questo progetto. Per eliminare il progetto, Le consigliamo di eliminare prima le unità. In questo modo, siamo sicuri al 100% che il progetto potrà essere eliminato.",
        "mupCantDeleteDeactivate": "Un'alternativa all'eliminazione del progetto è disattivarlo. In questo modo, tutte le informazioni verranno preservate per un uso futuro. Desidera disattivare questo progetto?"
      },
      "labels": {
        "activity": "Cronologia",
        "aftercare": "Post-vendita",
        "allLevels": "Tutti i livelli",
        "contacts": "Contatti",
        "conversations": "Conversazioni",
        "decisions": "Decisioni",
        "deleteProject": "È sicuro di voler eliminare {project_name}?",
        "deleteProjectDisclaimer": "L'eliminazione di questo progetto comporterà la perdita permanente di tutti i dati e i contenuti. Questa azione è irreversibile. In alternativa, valuti la disattivazione del progetto per preservare tutte le informazioni per un uso futuro. Proceda con cautela.",
        "deleteWarning": "Attenzione: l'eliminazione di questo livello comporterà l'eliminazione di tutti i livelli sottostanti, dei documenti, delle novità, delle FAQ e delle attività collegate a questo livello.",
        "documents": "Documenti",
        "download": "Scarica {level_name}",
        "generatingExport": "Generazione dell'esportazione",
        "hide": "Nascondi",
        "information": "Informazioni",
        "installment": "Finanze",
        "milestones": "Tappe",
        "multiple_selection": "Selezione multipla",
        "mupCantDelete": "Oh no, questa azione non è possibile.",
        "needMoreUnits": "Ha bisogno di più unità?",
        "reachedMax": "Ha creato l'unità assegnata a questo progetto. | Ha raggiunto le {count} unità assegnate a questo progetto.",
        "reachedMaxRundle": "Ha raggiunto il limite di 1 unità attiva. | Ha raggiunto il limite di {count} unità attive.",
        "requestMoreUnits": "Contatti il team Ziggu se desidera richiedere più unità attive.",
        "settings": "Impostazioni del progetto",
        "sharedWith": "Condiviso con ",
        "showForLevel": "Mostra {object} per livello",
        "spaces": "Pertinenze",
        "surveys": "Questionari",
        "tickets": "Conversazioni",
        "todos": "Attività",
        "todos_v2": "Attività v2",
        "willBeAssigned": "Disponibile per tutti in",
        "willBePublished": "Sarà mostrato a tutti in",
        "willBeUploaded": "Sarà caricato in"
      },
      "lot": "Lotto",
      "phase": "Fase",
      "project": "Progetto",
      "tooltip": {
        "add_level": "Aggiungi {level}"
      },
      "unit": "Unità"
    }
  }
}
